import { defineStore } from 'pinia';
import { userRole } from '@/Constants/roles';

export const useStoreMeta = defineStore('storeMeta', {
    state: () => ({
        city: 'Москва' as string,
        currency: '₽' as string,
        dealer: null as number | null,
        host: '' as string,
        role: '' as userRole,
        user: null as number | null,
        lockerUUID: '' as string,
        projectId: null as number | null,
        url: '' as string,
        addressEmail: '' as string,
        addressPhone: '' as string,
        addressSite: '' as string,
        addressValue: '' as string,
        addLockerFlag: 0 as number | undefined,
        email: '' as string,
        name: '' as string,
    }),
    actions: {
        setCity(value: string) {
            this.city = value;
        },
        setCurrency(value: string) {
            this.currency = value;
        },
        setDealer(value: number) {
            this.dealer = value;
        },
        setHost(value: string) {
            this.host = value;
        },
        setRole(value: userRole) {
            this.role = value;
        },
        setUser(value: number) {
            this.user = value;
        },
        setLockerUUID(value: string) {
            this.lockerUUID = value;
        },
        setProjectId(value: number) {
            this.projectId = value;
        },
        setUrl(value: string) {
            this.url = value;
        },
        setAddressEmail(value: string) {
            this.addressEmail = value;
        },
        setAddressPhone(value: string) {
            this.addressPhone = value;
        },
        setAddressSite(value: string) {
            this.addressSite = value;
        },
        setAddressValue(value: string) {
            this.addressValue = value;
        },
        setAddLockerFlag(value: number) {
            this.addLockerFlag = value;
        },
        setEmail(value: string) {
            this.email = value;
        },
        setName(value: string) {
            this.name = value;
        },
    },
});
